import React, { useState, useEffect } from "react";
// import wellnessIllustration from "assets/images/WeeklyIllustration.svg";
import ReactModal from "react-modal";

export const CardDetailsModal = ({ open, setOpen, data }) => {
  return (
    <ReactModal
      isOpen={open}
      onRequestClose={() => setOpen(false)}
      className="relative w-[100%] max-w-[90%] md:max-w-[460px] h-screen max-h-[340px] bg-transparent font-[Lato] outline-none overflow-visible"
      overlayClassName="fixed inset-0 flex items-center justify-center backdrop-blur-sm bg-black/50 z-50"
    >
      <div className="relative flex flex-col items-center"
      >
        <div className="w-[91px] h-[91px] object-cover mb-[-70px] z-10 rounded-full flex justify-center items-center"
        style={{
          backgroundColor:data?.tabColor
        }}>

        {data?.icon &&
          React.cloneElement(data?.icon, {
            className:
              "w-[56px] h-[56px] object-cover z-10 rounded-full",
          })}
        </div>
      </div>

      <div className="space-y-2 w-full bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] shadow-xl  rounded-[24px] overflow-y-auto max-h-[calc(80vh-80px)] pt-[80px] pb-3 px-5">
        <div className="flex justify-center">
          <h3 className="bg-white  py-1 px-3 rounded-full text-[#15AAFC] text-[18px] md:text-[24px] font-[Lato] font-[500]">
            {data?.label}
          </h3>
        </div>
        <div className="p-2 rounded-xl bg-white">
          <p className="text-[14px] md:text-[18px] text-[#5C5C5C] text-center">
            {data?.model_value}
          </p>
        </div>
      </div>
    </ReactModal>
  );
};
